import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { ANY_SPORT_MARKET_COMMON_PACKS } from '#src/constants/__generated__/routes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';

// TODO:  get active card set from API
const ACTIVE_CARD_SET_SLUG = 'winter';

export const MobileSeriesUserCurrencies = () => {
  const { generateSportContextPath } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  const {
    flags: { enableNavToggleProSet = false },
  } = useFeatureFlags();

  const shardsBalance = getCommonCardShardsCount(
    currentUser,
    ACTIVE_CARD_SET_SLUG
  );

  const showGems =
    !enableNavToggleProSet || !currentUser?.anyUserSportProfile?.proUnlocked;

  return (
    <Horizontal>
      {!!showGems && (
        <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      )}
      <EssenceBalance
        value={shardsBalance || 0}
        rarity={Rarity.common}
        cardSetSlug={ACTIVE_CARD_SET_SLUG}
        to={generateSportContextPath(ANY_SPORT_MARKET_COMMON_PACKS)}
      />
    </Horizontal>
  );
};
